<template>
  <!--
  We use the Grid Layout based on a GraphQL query
  -->
  <grid-layout :query="require('@/graphql/News.gql')" :variables="{}"
               :theme="'blue'"
               :type="'infos'"
               :title-text="'Actualités et Mises à Jour'"
               :name-text="'Actualités et Mises à Jour'"
               :page-size="pageSize"
  >
    <!--
    And in the Grid Layout, we will need to use this slot
    -->
    <template v-slot:main-section="props">
      <card-simple-actu v-for="(info, index) in props.data.infos.edges" :key="index" :actu="info"/>
    </template>

  </grid-layout>
</template>

<script>
  import GridLayout from "../components/Layout/GridLayout";
  import CardSimpleActu from "../components/Card/Models/Card-simple-actu";

  export default {
    name: "MajAndNews",
    components: {CardSimpleActu, GridLayout},

    data: () => {
      return {
        // par defaut: page 1
        page: 1,
        // nb of items per page
        pageSize: 9,
      }
    },
  }
</script>

<style lang="scss">

</style>